<template>
  <div
    class="d-flex flex-column align-items-stretch flex-shrink-0 bg-white mb-2"
  >
    <div
      class="d-flex justify-content-between align-items-center flex-shrink-0 p-2 link-dark text-decoration-none border-bottom"
    >
      <div class="fs-5 fw-semibold mx-0">
        Main Contact
      </div>
      <div><i class="bi bi-person-lines-fill icon-size"></i></div>
    </div>
    <div class="list-group list-group-flush border-bottom scrollarea">
      <div
        class="list-group-item list-group-item-action py-2 lh-tight account-tab bg-gradient"
        aria-current="true"
      >
        <div class="d-flex w-100 align-items-center justify-content-between">
          <strong class="mb-1">Account Holder</strong>
          <small><i class="bi bi-dot"></i></small>
        </div>
        <div class="col-10 mb-1 small">
          {{ accountInfo.firstName }} {{ accountInfo.lastName }}
        </div>
      </div>

      <div
        class="list-group-item list-group-item-action py-2 lh-tight account-tab bg-gradient"
        aria-current="true"
      >
        <div class="d-flex w-100 align-items-center justify-content-between">
          <strong class="mb-1">Account Claim{{ multiClaim ? "s" : "" }}</strong>
          <small><i class="bi bi-dot"></i></small>
        </div>
        <div class="col-12 mb-1 small">
          <ul class="list-group ">
            <li
              class="list-group-item"
              v-for="(claim, index) in accountInfo.userClaims"
              :key="index"
            >
              <p>{{ claim.claimType }}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div class="d-flex flex-column align-items-stretch flex-shrink-0 bg-white">
    <div
      class="d-flex justify-content-between align-items-center flex-shrink-0 p-2 link-dark text-decoration-none border-bottom"
    >
      <div class="fs-5 fw-semibold mx-0">
        Account Info
      </div>
      <div><i class="bi bi-person-lines-fill icon-size"></i></div>
    </div>
    <div class="list-group list-group-flush border-bottom scrollarea">
      <div
        class="list-group-item list-group-item-action py-2 lh-tight tab bg-gradient"
        aria-current="true"
      >
        <div class="d-flex w-100 align-items-center justify-content-between">
          <strong class="mb-1">Account No</strong>
          <small><i class="bi bi-dot"></i></small>
        </div>
        <div class="col-10 mb-1 small">
          {{ accountInfo.accountId }}
        </div>
      </div>
      <div
        class="list-group-item list-group-item-action py-2 lh-tight tab bg-gradient"
        aria-current="true"
      >
        <div class="d-flex w-100 align-items-center justify-content-between">
          <strong class="mb-1">Company Name</strong>
          <small><i class="bi bi-dot"></i></small>
        </div>
        <div class="col-10 mb-1 small">
          {{ accountInfo.companyName }}
        </div>
      </div>
      <div
        class="list-group-item list-group-item-action py-2 lh-tight tab bg-gradient"
        aria-current="true"
      >
        <div class="d-flex w-100 align-items-center justify-content-between">
          <strong class="mb-1">Account Holder</strong>
          <small><i class="bi bi-dot"></i></small>
        </div>
        <div class="col-10 mb-1 small">
          {{ accountInfo.firstName }} {{ accountInfo.lastName }}
        </div>
      </div>
      <div
        class="list-group-item list-group-item-action py-2 lh-tight tab bg-gradient"
        aria-current="true"
      >
        <div class="d-flex w-100 align-items-center justify-content-between">
          <strong class="mb-1">Account Type</strong>
          <small><i class="bi bi-dot"></i></small>
        </div>
        <div class="col-10 mb-1 small">
          {{ accountInfo.accountType }}
        </div>
      </div>
      <div
        v-if="accountInfo.accountType === 'PPS'"
        class="list-group-item list-group-item-action py-2 lh-tight tab bg-gradient"
        aria-current="true"
      >
        <div class="d-flex w-100 align-items-center justify-content-between">
          <strong class="mb-1">PPS Package</strong>
          <small><i class="bi bi-dot"></i></small>
        </div>
        <div class="col-10 mb-1 small">
          {{ accountInfo.ppsPackageType }}
        </div>
      </div>
      <div
        class="list-group-item list-group-item-action py-2 lh-tight tab bg-gradient"
        aria-current="true"
      >
        <div class="d-flex w-100 align-items-center justify-content-between">
          <strong class="mb-1">RITA Status</strong>
          <small><i class="bi bi-dot"></i></small>
        </div>
        <div class="col-10 mb-1 small">
          {{ accountInfo.ritaAccountStatus }}
        </div>
      </div>
      <div
        class="list-group-item list-group-item-action py-2 lh-tight tab bg-gradient"
        aria-current="true"
      >
        <div class="d-flex w-100 align-items-center justify-content-between">
          <strong class="mb-1">Call Routing Account Status</strong>
          <small><i class="bi bi-dot"></i></small>
        </div>
        <div class="col-10 mb-1 small">
          {{ accountInfo.callRoutingAccountStatus }}
        </div>
      </div>
      <div
        class="list-group-item list-group-item-action py-1 lh-tight tab bg-gradient"
        aria-current="true"
      >
        <div class="d-flex w-100 align-items-center justify-content-between">
          <strong class="mb-1">Billing Account Status</strong>
          <small><i class="bi bi-dot"></i></small>
        </div>
        <div class="col-10 mb-1 small">
          {{ accountInfo.billingAccountStatus }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SearchByNumber } from "@/services/account.js";
import { ref, computed, watch } from "vue";

export default {
  props: {
    number: {
      type: String,
      required: true,
    },
  },

  async setup(props) {
    watch(
      () => props.number,
      async (newNumber) => {
        accountInfo.value = await SearchByNumber(newNumber);
      }
    );
    let accountInfo = ref(await SearchByNumber(props.number));
    const multiClaim = computed(
      () => accountInfo.value?.userClaims?.length > 1
    );

    return { accountInfo, multiClaim };
  },
};
</script>

<style scoped>
.account-tab {
  background-color: #efefef;
}
.tab {
  background-color: #b2e6e6;
}
</style>
